import React from 'react';

export function WidgetStatus ({ type, text }) {
    return (<span className={`label label-light-${type} label-pill label-inline`}>{text}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetStatus.displayName = 'WidgetStatus';
}
